import { QuestionsType } from '@shared/api/rest/survey';
import { Answers } from '../answers';
import { TextAnswer } from '../textAnswer';
import clsx from 'clsx';
import { FieldError } from 'react-hook-form';

interface QuestionType {
  className: string;
  question: QuestionsType;
  value: QuestionsType[] | null;
  onChange: (value: string | null) => void;
  error?: FieldError;
}

export const Question = (props: QuestionType) => {
  return (
    <div className={clsx(props.className, 'flex flex-col justify-center')}>
      {props.question.CategoryType ? (
        <>
          {props.question.Answers ? (
            <div className='mx-5'>
              <h2 className='text-base font-medium text-left'>{props.question.Name}</h2>
              {props.question.Answers && <Answers question={props.question} value={props.value} onChange={props.onChange} />}
              {props.error && <div className='text-[#d00000] text-sm mt-2.5 max-w-[744px] w-full'>{props.error.message}</div>}
            </div>
          ) : (
            <TextAnswer
              className='w-full max-w-[744px]'
              caption={props.question.Name}
              value={props.value}
              onChange={props.onChange}
              question={props.question}
              type={props.question.CategoryType}
              title={props.question.Title}
              error={props.error}
            />
          )}
        </>
      ) : (
        <div className={clsx('text-left border-b border-gray-400 pb-5')}>
          <div className='mx-5'>
            <h3 className='text-[22px] text-[#2c3344] font-semibold'>{props.question?.Title}</h3>
            <div className='text-[13px] font-normal'>{props.question?.Name}</div>
          </div>
        </div>
      )}
    </div>
  );
};
